import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-0 bg-white px-4 border-t border-gray-100" data-id="element-110">
      <div className="max-w-3xl mx-auto text-center" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-col items-center" data-id="element-112">
          <div className="w-24 h-24 bg-brand-50 rounded-full flex items-center justify-center mb-6 border-4 border-white shadow-lg shadow-brand-100/50" data-id="element-113">
            <ShieldCheck className="w-12 h-12 text-brand-500" data-id="element-114" />
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold mb-4 text-gray-900" data-id="element-115">
            🛡️ GARANTÍA 7 DÍAS
          </h2>
          <p className="text-xl text-gray-800 font-bold mb-2" data-id="element-116">
            Probá el Mega Pack sin riesgo.
          </p>
          <p className="text-gray-600 text-lg font-medium" data-id="element-117">
            Si no es lo que esperabas, te devolvemos el dinero.{' '}
            <br className="hidden sm:block" data-id="element-118" />
            Sin preguntas.
          </p>
        </motion.div>
      </div>
    </section>;
}